<template>
	<div class="page" data-name="test-layout1">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        프로그램 정보
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
	</div>
</template>

<script>
import MODULE from '../../js/common/module';
import Vue from 'vue';
import PAGES from '../../js/pages';
import CONST from '../../js/common/constant';
import API from '../../js/common/api';
import AUTH from '../../js/common/auth';

export default {
  data() {
    return {

    }
  },
  mounted() {



  },
  methods: {
  }
}

</script>